import type { IconComponent } from '../types';

/** Checkmark Symbol */
export const Check: IconComponent = ({
  width,
  height,
  ...restOfProps
}) => <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 25 21' fill='none' {...restOfProps} data-sentry-element="svg" data-sentry-component="Check" data-sentry-source-file="index.tsx">
        <path d='M2.04102 13.2569L7.18387 18.7954L22.041 2.79541' stroke='white' strokeWidth='4' strokeLinecap='round' strokeLinejoin='round' data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;